// extracted by mini-css-extract-plugin
module.exports = {"quickNavigateLocation":"QuickNavigateLocations_quickNavigateLocation__2jVNn","quickNavigateLocationContainer":"QuickNavigateLocations_quickNavigateLocationContainer__101f6"};